import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

export const SITE_TITLE = 'Säädöspankki';

/** "Page – Säädöspankki" for a page's own title, or the site name alone. */
export function pageTitle(page: string | null | undefined): string {
  return page ? `${page} – ${SITE_TITLE}` : SITE_TITLE;
}

/** Sets the document title from each route's `title`, so every page has a distinct one. */
@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.title.setTitle(pageTitle(this.buildTitle(snapshot)));
  }
}
